import { ENABLE_AFFIRM_TOKENIZATION } from './ld-user';
import { trackAffirmInteraction } from './tracking/tracking';

export const AFFIRM_CARD_TYPE = 'AF';

export const openAffirmModal = (
  currentBookingInfo,
  setShowLoader,
  threeDsComponentElement,
  country,
  setMakePaymentInfo,
  showErrorNotificationAffirm,
  setAffirmChecked,
  balanceDue,
  ldFlags,
) => {
  const totalToPay = Number(balanceDue).toFixed(2).toString().replace('.', '');
  const checkout = {
    merchant: {
      name: 'Royal Caribbean International',
      use_vcn: true,
    },
    items: [
      {
        display_name: 'Booking',
        sku: currentBookingInfo?.flightProfile.id,
        unit_price: totalToPay,
        qty: 1,
        item_image_url: '',
        item_url: '',
      },
    ],
    order_id: currentBookingInfo?.flightProfile.id,
    metadata: {
      mode: 'modal',
    },
    shipping_amount: 0,
    tax_amount: 0,
    total: totalToPay,
  };

  window.affirm.checkout.open_vcn({
    success(cardResponse) {
      const affirmVirtualCard = [
        {
          correlationId: cardResponse.number.substr(-4),
          order: {
            bookingId: String(+currentBookingInfo.id),
            currency: String(currentBookingInfo.price.currencyCode),
            country,
          },
          paymentMethod: {
            cardNumber: cardResponse.number,
            expirationYear: `20${cardResponse.expiration.slice(-2)}`,
            expirationMonth: cardResponse.expiration.substring(0, 2),
          },
        },
      ];
      if (ldFlags[ENABLE_AFFIRM_TOKENIZATION]) {
        threeDsComponentElement.tokenizeCards(affirmVirtualCard).then(async (cards) => {
          const haveErrors = cards.find((card) => card.errorDescription);
          if (!haveErrors) {
            const cardsTokens = [];
            const { expirationMonth, expirationYear } = affirmVirtualCard[0].paymentMethod;
            cardsTokens.push({
              firstNameOnCard: cardResponse.cardholder_name,
              cardType: AFFIRM_CARD_TYPE,
              cardNumber: cards[0].paymentMethod.cardToken,
              expiration: `${expirationMonth}${expirationYear.slice(-2)}`,
              amount: balanceDue,
              cvv: cardResponse.cvv,
              isThreeDsEligible: false,
              paymentMethod: 'CC',
            });

            const payloadMakePayment = {
              variables: {
                makePaymentInput: cardsTokens,
              },
            };
            setMakePaymentInfo(payloadMakePayment);
          } else {
            setShowLoader(false);
            showErrorNotificationAffirm();
            trackAffirmInteraction('error:0001');
          }
        });
      } else {
        const { expirationMonth, expirationYear } = affirmVirtualCard[0].paymentMethod;
        const paymentInfo = [
          {
            cardType: AFFIRM_CARD_TYPE,
            firstNameOnCard: cardResponse.cardholder_name,
            cardNumber: cardResponse.number,
            expiration: `${expirationMonth}${expirationYear.slice(-2)}`,
            amount: balanceDue,
            cvv: cardResponse.cvv,
            paymentMethod: 'CC',
          },
        ];
        const payloadMakePayment = {
          variables: {
            makePaymentInput: paymentInfo,
          },
        };
        setMakePaymentInfo(payloadMakePayment);
      }
    },
    error(res) {
      setShowLoader(false);
      if (res.reason === 'canceled') {
        setAffirmChecked(false);
        trackAffirmInteraction('declined');
      } else {
        showErrorNotificationAffirm();
        trackAffirmInteraction('error:0001');
      }
    },
    checkout_data: checkout,
  });
  return window.affirm.checkout.open_vcn;
};

export default { openAffirmModal };
